// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-county-rankings-js": () => import("./../../../src/pages/county-rankings.js" /* webpackChunkName: "component---src-pages-county-rankings-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-interactive-js": () => import("./../../../src/pages/interactive.js" /* webpackChunkName: "component---src-pages-interactive-js" */),
  "component---src-pages-place-rankings-js": () => import("./../../../src/pages/place-rankings.js" /* webpackChunkName: "component---src-pages-place-rankings-js" */)
}

